//styles
import gsap from 'gsap/all';
import {initInsightsSection} from "./custom/insights";
import {
    isThereСlass,
    initMagnetBtn,
    initSplitText,
    initFades,
} from './common/help_functions';
import {initTopSliderSection} from "./custom/section_top_slider";

require("../css/style.scss");

//vendor
require("./vendor/jquery.viewportchecker");
require("./vendor/lightbox.js");
require("./vendor/slick.min.js");


require("./vendor/isotope.pkgd.min");
require("./vendor/packery-mode.pkgd");



require("./vendor/onyx-video-player.js");
require("./vendor/inline_svg/jquery.inlinesvg");
require("./vendor/onyx-map.js");
require("./vendor/jquery.validate.js");
require("./vendor/vue.min.js");
require("./vendor/parallax.js/parallax.min");
require("./vendor/vue-carousel-3d.min.js");
require("./vendor/jquery.cookie.js");
require("./vendor/jquery.isonscreen.js");
require("./vendor/TweenMax.min.js");
require("./vendor/select2.min.js");
require("./vendor/owl.carousel.min.js");
require("./vendor/parallax_content.js");
require("./vendor/parallax_background.js");
require("./vendor/parallax.js/parallax.min.js");

//custom
require("./custom/script.js");
require("./custom/entry.js");
require("./custom/registration-form.js");
require("./custom/events.js");
require("./custom/hubspot-form.js");
require("./custom/vue-slider.es6");
require("./custom/isotope-resources.js");
require("./custom/marketo-forms.js");
require("./custom/hotels-travel_agents-homepage-sect.js");
require("./custom/resources-ajax.es6");
require("./custom/section_top_slider");
require("./custom/insights.js");

(function ($) {

    $(".section-full-width-slider").length > 0 && require("./custom/section_full_width_slider.js")
    $(".section-multi-slider").length > 0 && require("./custom/section_multi_slider.js")
    $(".brand-slider-section-type-1").length > 0 && require("./custom/section_brand_slider")
    $(".calculate_commissions_section").length > 0 && require("./custom/calculate_commissions_section.es6")

})(jQuery);

window.addEventListener("load", () => {

    initFades('.-fade');
    gsap.to('body', {
        opacity: 1,
        duration: 2
    });

    initSplitText('.split');
    (isThereСlass('.btn-magnet')) ? initMagnetBtn() : '';
    (isThereСlass('.insights-section')) ? initInsightsSection() : '';
    (isThereСlass('.section-top-slider')) ? initTopSliderSection() : '';
    (isThereСlass('.insights-section')) ? initInsightsSection() : '';

    $('.parallax-window').parallax({

    });
});




// WEBPACK FOOTER //
// ./src/js/entry.es6